import * as actions from '../constants';
var initialState = {
  isFetching: false
};
export var loginStatus = function loginStatus() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case actions.LOG_IN_PROCESS_REQUEST:
      return {
        isFetching: true
      };

    case actions.LOG_IN_PROCESS_FAILURE:
    case actions.LOG_IN_PROCESS_SUCCESS:
    case actions.CLEAR_LOGIN_FORM:
      return {
        isFetching: false
      };

    default:
      return state;
  }
};